<button [matTooltip]="tooltip()" [queryParams]="queryParams()" [routerLink]="['/', 'status-check']" class="px-3 py-3">
  <span class="flex flex-row gap-4 items-center">
    <span [ngClass]="{
    'bg-red-500': status() === 'error',
    'bg-green-500': status() === 'ok',
    'bg-yellow-500': status() === 'loading',
    'bg-black': !['error', 'ok', 'loading'].includes(status()),
    }" class="indicator w-3 h-3 rounded-full"></span>
  </span>
</button>
